import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Colors } from '../../../scss/common/style';

const ErrorLabel = ({ error }) => {
  return <StyledErrorLabel>{error}</StyledErrorLabel>;
};

export default ErrorLabel;

const StyledErrorLabel = styled.p`
  color: red;
  font-size: 12px;
  padding: 0;
`;
